import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { PatientAuthProvider, usePatientAuth } from "@/context/PatientAuthContext";
import PortalLogin from "@/pages/portal/PortalLogin";
import PortalDashboard from "@/pages/portal/PortalDashboard";
import { Loader2 } from "lucide-react";

function Guard({ children }) {
  const { patient } = usePatientAuth();
  if (patient === null) return <div className="h-screen grid place-items-center bg-slate-50"><Loader2 className="h-6 w-6 animate-spin text-teal-600" /></div>;
  if (patient === false) return <Navigate to="/portal/login" replace />;
  return children;
}

export default function PortalApp() {
  return (
    <PatientAuthProvider>
      <Routes>
        <Route path="login" element={<PortalLogin />} />
        <Route index element={<Guard><PortalDashboard /></Guard>} />
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Routes>
    </PatientAuthProvider>
  );
}
